export const events = {
  signIn: {
    user_signin: 'Sign In Tapped',
    app_landing_screen_viewed: 'App Landing Screen Viewed'
  },
  game: {
    game_created: 'Game Created',
    join_game: 'Game Joined',
    start_chatting_tapped: 'Start Chatting Tapped',
    scheduled_game_created: 'Scheduled Game Created',
    scheduled_game_shared: 'Scheduled Game Shared',
    schedule_game_added: 'Schedule Game Added',
    shedule_game_edited: 'Schedule Game Edited',
    create_quick_game_tapped: 'Create Quick Game Tapped',
    create_tournament_tapped: 'Create Tournament Tapped',
    from_profile_screen: 'Join Game Tapped',
    add_chips_modal_viewed: 'Add Chips Modal Viewed',
    add_chips_tapped: 'Add Chips Tapped',
    add_chips_succeeded: 'Add Chips Succeeded'
  },
  support: {
    support_form_submitted: 'Support Form Submitted'
  },
  logout: {
    user_logout: 'User Logout'
  },
  bottomNavigation: {
    home: 'Home Nav Tapped',
    play: 'Play Nav Tapped',
    learn: 'Learn Nav Tapped',
    read: 'Read Nav Tapped',
    profile: 'Profile Nav Tapped',
    premium: 'CTA Go Premium Tapped'
  },
  gamescreen: {
    game_screen_viewed: 'Game Screen Viewed',
    lets_play_button_tapped: 'Lets Play Button Tapped'
  },
  playscreen: {
    play_screen_viewed: 'Play Screen Viewed',
    advisor_promo_tapped: 'Advisor Promo Tapped'
  },
  homescreen: {
    home_screen_viewed: 'Home Screen Viewed',
    join_game: 'Join Game Tapped',
    create_game: 'Create Game Tapped',
    create_tournament: 'Create Tournament Tapped',
    practice_game: 'Practice Game Tapped',
    lounges: 'Lounges Tapped',
    refer_friend: 'Refer a Friend Tapped',
    online_virtual_lessons: 'Online Lessons Tapped',
    cheat_sheet: 'Cheat Sheet Tapped',
    table_tour: 'Table Tour Tapped',
    table_tour_started: 'Table Tour Started',
    table_tour_finished: 'Table Tour Finished',
    raise_or_fold_tapped: 'Raise or Fold Tapped',
    raise_or_fold_started: 'Raise or Fold Started',
    raise_or_fold_completed: 'Raise or Fold Completed',
    raise_or_fold_play_again_tapped: 'Raise or Fold Play Again Tapped',
    deal_the_flop_tapped: 'Deal the Flop Tapped',
    deal_the_flop_started: 'Deal the Flop Started',
    deal_the_flop_completed: 'Deal the Flop Completed',
    deal_the_flop_play_again_tapped: 'Deal the Flop Play Again Tapped',
    lesson_module_started: 'Lesson Module Started',
    lesson_module_completed: 'Lesson Module Completed',
    learn_basics_tapped: 'Learn Basics Tapped',
    chat_screen_viewed: 'Chat Screen Viewed',
    chat_sent: 'Chat Sent',
    audio_toggled_on: 'Audio Toggled On',
    video_toggled_on: 'Video Toggled On',
    audio_toggled_off: 'Audio Toggled Off',
    video_toggled_off: 'Video Toggled Off',
    motivation_engaged: 'Motivation Engaged',
    motivation_cta_tapped: 'Motivation CTA Tapped',
    post_event_rating: 'Post Event Rating',
    CTA_go_premium_tapped: 'CTA Go Premium Tapped',
    play_to_win_tapped: 'Play to Win Tapped',
    try_it_out_tapped: 'Try It Out Tapped'
  },
  dailyTask: {
    daily_tasks_completed: 'Daily Tasks Completed',
    daily_tasks_started: 'Daily Tasks Started',
    task_started: 'Task Started',
    task_completed: 'Task Completed'
  },
  onboarding: {
    onboarding_slide_viewed: 'Onboarding Slide Viewed',
    completed_sign_up: 'Completed Sign Up',
    poker_name_created: 'Poker Name Created',
    pronoun_form_completed: 'Pronoun Form Completed',
    skills_form_completed: 'Skills Form Completed',
    referral_form_completed: 'Referral Form Completed',
    reason_form_completed: 'Reason Form Completed',
    event_form_completed: 'Event Form Completed',
    class_type_form_completed: 'Class Type Form Completed',
    welcome_start_playing_tapped: 'Welcome Start Playing Tapped',
    where_are_you_form_completed: 'Where Are You Form Completed',
    which_event_form_completed: 'Which Event Form Completed',
    age_form_completed: 'Age Form Completed'
  },
  joinScreen: {
    join_screen_viewed: 'Join Screen Viewed'
  },
  joinLiveScreen: {
    join_quick_game_tapped: 'Join Quick Game tapped',
    join_open_tournament_tapped: 'Join Open Tournament tapped'
  },
  sideNav: {
    shop_link_tapped: 'Shop Link Tapped',
    drawer_opened: 'Drawer Opened',
    drawer_closed: 'Drawer Closed'
  },
  advisor: {
    welcome_shown: 'Advisor Welcome Shown',
    level_changed: 'Advisor Level Changed',
    muted: 'Advisor Muted',
    unmuted: 'Advisor Unmuted',
    advice_shown: 'Advisor Advice Shown',
    advice_followed: 'Advisor Advice Followed',
    advice_deviated: 'Advisor Advice Deviated',
    feedback_shown: 'Advisor Feedback Shown',
    dismissed_bubble: 'Advisor Bubble Dismissed'
  },
  gameOverScreen: {
    leaderboard_button_tapped: 'Leaderboard Button Tapped',
    game_celebrated: 'Game Celebrated',
    hand_celebrated: 'Hand Celebrated',
    show_cards_tapped: 'Show Cards Tapped',
    show_cards_drawer_viewed: 'Show Cards Drawer Viewed'
  },
  threeCard: {
    viewed: 'Pokerish Viewed',
    started: 'Pokerish Started',
    hand_played: 'Pokerish Hand Played',
    exited: 'Pokerish Exited',
    finished: 'Pokerish Finished',
    shared: 'Pokerish Shared'
  },
  daily10: {
    play_screen_card_tapped: 'Daily10 Play Card Tapped',
    results_tapped: 'Daily10 Results Tapped',
    results_share_tapped: 'Daily10 Results Share Tapped',
    leaderboard_tapped: 'Daily10 Leaderboard Tapped'
  },
  cth: {
    play_screen_card_tapped: 'CTH Play Card Tapped',
    play_tapped: 'CTH Play Tapped',
    resume_tapped: 'CTH Resume Tapped',
    results_tapped: 'CTH Results Tapped',
    replay_tapped: 'CTH Replay Tapped',
    leaderboard_tapped: 'CTH Leaderboard Tapped',
    results_share_tapped: 'CTH Results Share Tapped',
    profile_history_tapped: 'CTH History Tapped'
  },
  pocketPick: {
    play_screen_card_tapped: 'Pocket Pick Play Card Tapped',
    play_tapped: 'Pocket Pick Play Tapped',
    resume_tapped: 'Pocket Pick Resume Tapped',
    results_tapped: 'Pocket Pick Results Tapped',
    replay_tapped: 'Pocket Pick Replay Tapped',
    leaderboard_tapped: 'Pocket Pick Leaderboard Tapped',
    results_share_tapped: 'Pocket Pick Results Share Tapped',
    profile_history_tapped: 'Pocket Pick History Tapped'
  },
  badges: {
    page_viewed: 'Badges Page Viewed',
    teaser_tapped: 'Badges Play Teaser Tapped',
    profile_row_tapped: 'Badges Profile Row Tapped',
    detail_opened: 'Badge Detail Opened'
  },
  diamonds: {
    page_viewed: 'Diamonds Page Viewed',
    profile_row_tapped: 'Diamonds Profile Row Tapped'
  },
  scheduleNotifications: {
    set_reminder_tapped: 'Set Reminder Tapped'
  },
  videoLessons: {
    lesson_tapped: 'Lesson Tapped',
    lesson_started: 'Lesson Started',
    lesson_completed: 'Lesson Completed',
    chapter_started: 'Chapter Started',
    chapter_completed: 'Chapter Completed'
  },
  gameStats: {
    leaderboard_displayed: 'Leaderboard Button Displayed',
    leaderboard_tapped: 'Leaderboard Button Tapped',
    post_game_stats_screen_viewed: 'Post Game Stats Screen Viewed',
    post_game_stats_screen_exited: 'Post Game Stats Exited',
    game_stats_button_viewed: 'Game Stats Button Viewed',
    game_stats_button_tapped: 'Game Stats Button Tapped'
  },
  dailyInspirationEvents: {
    response_started: 'Response Started',
    response_submitted: 'Response Submitted',
    response_canceled: 'Response Canceled',
    read_responses_tapped: 'Read Responses Tapped',
    response_engaged: 'Response Engaged',
    response_reported: 'Response Reported'
  },
  emailUpdates: {
    onboarding_email_optin_selected: 'Onboarding Email Optin Selected',
    onboarding_email_skip_selected: 'Onboarding Email Skip Selected',
    onboarding_email_screen_viewed: 'Onboarding Email Screen Viewed'
  },
  realtimeUpdates: {
    onboarding_notif_button_enable: 'Onboarding Notif Button Enable',
    onboarding_notif_button_skip: 'Onboarding Notif Button Skip',
    onboarding_notif_screen_viewed: 'Onboarding Notif Screen Viewed'
  },
  notificationSettings: {
    notification_settings_screen_viewed: 'Notification Settings Screen Viewed',
    notification_toggle_general_updated: 'Notification Toggle General Updated',
    notification_toggle_community_game_updated: 'Notification Toggle Community Game Updated'
  },
  av: {
    button_tapped: 'AV Button Tapped',
    controls_opened: 'AV Controls Opened',
    controls_dismissed: 'AV Controls Dismissed',
    mic_toggled: 'AV Mic Toggled',
    camera_toggled: 'AV Camera Toggled',
    channel_auto_joined: 'AV Channel Auto-Joined',
    permissions_granted: 'AV Permissions Granted',
    permissions_denied: 'AV Permissions Denied'
  },
  teacherSeat: {
    teacher_seat_joined: 'Teacher Seat Joined',
    teacher_seat_left: 'Teacher Seat Left'
  },
  read: {
    filter_tapped: 'Article Filter Tapped', // A category chip on the Read tab was tapped.
    article_opened: 'Article Opened', // An article row was tapped. `article_index` is its position in the list the reader saw.
    article_progress: 'Article Progress', // Fired once per visit at each of READ_PROGRESS_MILESTONES (`percent`).
    article_completed: 'Article Completed', // Fired once per article, the first time the reader crosses COMPLETION_THRESHOLD.
    article_closed: 'Article Closed' // The reader left the article; `percent_read` is how far they got this visit.
  },
  lounge: {
    create_lounge_tapped: 'Create Lounge Tapped',
    create_lounge_submitted: 'Create Lounge Submitted',
    join_lounge_tapped: 'Join Lounge Tapped',
    join_lounge_submitted: 'Join Lounge Submitted',
    join_lounge_link_opened: 'Join Lounge Link Opened',
    join_lounge_link_failed: 'Join Lounge Link Failed',
    lounge_chat_tapped: 'Lounge Chat Tapped',
    lounge_chat_sent: 'Lounge Chat Sent',
    lounge_tab_pressed: 'Lounge Tab Pressed'
  },
  mtt: {
    create_screen_viewed: 'MTT Create Screen Viewed',
    create_submitted: 'MTT Create Submitted',
    lobby_screen_viewed: 'MTT Lobby Screen Viewed',
    register_tapped: 'MTT Register Tapped',
    unregister_tapped: 'MTT Unregister Tapped',
    share_tapped: 'MTT Share Tapped',
    start_now_tapped: 'MTT Start Now Tapped',
    go_to_table_tapped: 'MTT Go To Table Tapped',
    join_late_tapped: 'MTT Join Late Tapped',
    leave_waitlist_tapped: 'MTT Leave Waitlist Tapped',
    reentry_modal_viewed: 'MTT Re-entry Modal Viewed',
    reentry_tapped: 'MTT Re-entry Tapped',
    winner_modal_viewed: 'MTT Winner Modal Viewed',
    leave_tournament_tapped: 'MTT Leave Tournament Tapped',
    host_bot_prompt_viewed: 'MTT Host Bot Prompt Viewed',
    continue_with_bots_tapped: 'MTT Continue With Bots Tapped',
    end_tournament_now_tapped: 'MTT End Tournament Now Tapped',
    leaderboard_screen_viewed: 'MTT Leaderboard Screen Viewed',
    tables_screen_viewed: 'MTT Tables Screen Viewed',
    spectate_table_tapped: 'MTT Spectate Table Tapped',
    /** Fired after the spectate mutation commits successfully, before the redirect. */
    spectate_table_succeeded: 'MTT Spectate Table Succeeded',
    /** Fired when the spectate mutation rejects. `reason` is the error message. */
    spectate_table_failed: 'MTT Spectate Table Failed',
    summary_screen_viewed: 'MTT Summary Screen Viewed'
  }
}
